import { ActionBarItem } from '@workwave-tidal/core/components/ActionBar'
import { Close } from '@workwave-tidal/core/icons'
import { ModalHeader } from '@/components/Modal'

import { useController } from '../../hooks/useController'
import { useTexts } from './useTexts'

export function SendMessageHeader() {
  const texts = useTexts()
  const { close, data } = useController()

  return data.gpsOnly ? (
    <ModalHeader
      actions={[<ActionBarItem icon={<Close />} key="close" onClick={close} label="" />]}
      title={texts.gpsOnlyTitle}
      subtitle={texts.gpsOnlySubtitle}
    />
  ) : (
    <ModalHeader
      actions={[<ActionBarItem icon={<Close />} key="close" onClick={close} label="" />]}
      title={texts.title}
      subtitle={data.driverName}
    />
  )
}
